// extracted by mini-css-extract-plugin
export default {"container2":"MyPage_container2__dHwlD","containerBox":"MyPage_containerBox__AYr9G","h1":"MyPage_h1__f2reK","retouch":"MyPage_retouch__bYn+l","retouch_a":"MyPage_retouch_a__5cN1X"};